import Cookies from 'js-cookie';
import * as actionTypes from '../constants/orderConstants';
import axios from 'axios';

export const createOrder = (addressId, paymentType) => {
  return async (dispatch) => {
    try {
      const token = Cookies.get("uaTfl");
      console.log("Token:", token);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const cData = sessionStorage.getItem('cData');
      console.log(cData)
      const response = await axios.post(`/api/v1/order/new`, { addressId, cData, paymentType }, headers);
      console.log("Response:", response);

      dispatch({ type: actionTypes.CREATE_ORDER_REQUEST });
      const { captcha } = response.data;
      console.log("Captcha Image:", captcha);

      if (response.status === 200) {
        dispatch({ type: actionTypes.CREATE_ORDER_SUCCESS, payload: captcha });
      } else {
        dispatch({ type: actionTypes.CREATE_ORDER_FAILURE, payload: response.data.error });
      }
      return response;
    } catch (error) {
      console.log("Error:", error);
      dispatch({ type: actionTypes.CREATE_ORDER_FAILURE, payload: error.message });
    }
  };
};

export const verifyCaptchaAndUpdateOrder = (orderId, captchaInput) => {
  return async (dispatch) => {
    try {
      const token = Cookies.get("uaTfl");
      console.log("Token:", token);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(`/api/v1/order/confirm-order`, { orderId, captchaCode: captchaInput }, headers);
      console.log("Response:", response);

      dispatch({ type: actionTypes.VERIFY_CAPTCHA_REQUEST });

      if (response.status === 200) {
        // Include the orderId in the payload
        dispatch({ type: actionTypes.VERIFY_CAPTCHA_SUCCESS, payload: { message: response.data } });
      } else {
        dispatch({ type: actionTypes.VERIFY_CAPTCHA_FAILURE, payload: { error: response.data.error } });
      }

      return response;
    } catch (error) {
      console.log("Error:", error);
      dispatch({ type: actionTypes.VERIFY_CAPTCHA_FAILURE, payload: { error: error.message } });
    }
  };
};
export const refreshCaptcha = (orderId) => {
  return async (dispatch) => {
    try {
      const token = Cookies.get("uaTfl");
      console.log("Token:", token);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(`/api/v1/orders/refresh-captcha`, { orderId }, headers);
      console.log("Response:", response);

      dispatch({ type: actionTypes.REFRESH_CAPTCHA_REQUEST });
      const { image } = response.data;
      console.log("Captcha Image:", image);

      if (response.status === 200) {
        dispatch({ type: actionTypes.REFRESH_CAPTCHA_SUCCESS, payload: image });
      } else {
        dispatch({ type: actionTypes.REFRESH_CAPTCHA_FAILURE, payload: response.data.error });
      }

      return response;
    } catch (error) {
      console.log("Error:", error);
      dispatch({ type: actionTypes.REFRESH_CAPTCHA_FAILURE, payload: error.message });
    }
  };
};

export const getIndividualOrder = (id) => async (dispatch) => {
  console.log(id);
  try {
    dispatch({ type: actionTypes.ORDER_DETAILS_REQUEST });
    const token = Cookies.get("uaTfl");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Your authorization token
      },
    };

    const response = await axios.post(
      `/api/v1/order/${id}`,
      null,
      config
    );

    if (response.status === 200) {
      dispatch({
        type: actionTypes.ORDER_DETAILS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: actionTypes.ORDER_DETAILS_FAIL,
        payload:
          response.data.message ||
          `Request failed with status code ${response.status}`,
      });
    }

    // Return the response to the caller
    return response;
  } catch (error) {
    console.error('Request error:', error);
    dispatch({
      type: actionTypes.ORDER_DETAILS_FAIL,
      payload: error.message,
    });
    throw error; // Re-throw the error to be caught by the caller
  }
};

export const getUserOrders = (user) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.USER_ALL_ORDERS_REQUEST });
    const token = Cookies.get("uaTfl");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Your authorization token
      },
    };

    const response = await axios.post(
      `/api/v1/orders/your-order/${user}`,
      {},
      config
    );

    if (response.status === 200) {
      console.log(response.data);
      dispatch({
        type: actionTypes.USER_ALL_ORDERS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: actionTypes.USER_ALL_ORDERS_FAIL,
        payload:
          response.data.message ||
          `Request failed with status code ${response.status}`,
      });
    }

    // Return the response to the caller
    return response;
  } catch (error) {
    console.error('Request error:', error);
    dispatch({
      type: actionTypes.ORDER_DETAILS_FAIL,
      payload: error.message,
    });
    throw error; // Re-throw the error to be caught by the caller
  }
};
  